import bindModifyPhone from './bind-modify-phone'
export default bindModifyPhone